import Vue from 'vue'
import App from './App.vue'
import './index.scss'
import router from './router'
import * as Sentry from '@dida-sentry/h5'
import { BrowserTracing } from '@sentry/tracing'
import packageInfo from '../package.json'
import { BsSetWebp, BsUtil, BsGetEnv, VnToast, BsGetCid, BsTrack, BsShare } from 'dida-web-common'

// import { getQueryString } from '@common/libs/util.url.js'
// import Toast from '@common/components/vue/dida/toast/index.js'
// import { shareByWX } from '@common/libs/util.share.js'
// import Env from '@common/libs/util.env.js'
Vue.config.productionTip = false
Vue.use(VnToast)

// const CID =
//   getQueryString('cid') ||
//   getQueryString('user_cid') ||
//   getQueryString('userCid') ||
//   getQueryString('encrypted_cid') ||
//   sessionStorage.getItem('user_cid') ||
//   ''
const isInviter = BsUtil.queryString('type') === '0' // 0-inviter 1-invitee
const invitecode = BsUtil.queryString('invitecode') || ''
const role = BsUtil.queryString('role') || '' // 邀请人身份："0":乘客，"1":车主

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    release: packageInfo.name + '@' + packageInfo.version,
    environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
    dsn: 'https://6d39b4f839794dc38658ea1e632c722d@sentry.didapinche.com/17',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}

if (BsGetEnv.inWechat) {
  // 微信分享
  const objShare = {
    data: {
      title: '车主邀请',
      desc: '邀你做嘀嗒车主，立得212元现金礼包。',
      link:
        window.location.origin +
        window.location.pathname +
        '?type=0&role=' +
        role,
      imgUrl: 'https://static.didapinche.com/pics/g/npwrcdt2lxrshare.png'
    },
    shareByWx: {
      enable: true
    }
  }
  new BsShare(objShare)
}

(async function() {
  await BsSetWebp.init(Vue)
  const { cid } = await BsGetCid()
  new Vue({
    router,
    data: {
      cid: cid,
      is_spring_festivaled: false, // 春节皮肤-日常皮肤
      isInviter: isInviter,
      invitecode: invitecode,
      role
    },
    render: h => h(App)
  }).$mount('#app')
})()

const point = BsUtil.queryString('enter')
const source = BsUtil.queryString('source') || null
const pointName = () => {
  if (point === 'banner1') {
    return '车主邀请_乘客首页banner'
  } else if (point === 'banner2') {
    return '车主邀请_车主首页banner'
  } else if (point === 'side') {
    return '车主邀请_侧栏广告'
  } else if (point === 'bounce1') {
    return '车主邀请_乘客完单后弹窗'
  } else if (point === 'bounce2') {
    return '车主邀请_车主完单后弹窗'
  } else if (point === 'home') {
    return '车主邀请_首页弹窗'
  } else if (point === 'fl') {
    return '车主邀请_福利中心'
  } else if (point === 'radar') {
    return '车主邀请_雷达页banner'
  } else {
    return 'webhf684车主邀请'
  }
}
const sourceName = source ? '[' + source + ']' + pointName() : pointName()
window.myTrack = new BsTrack({
  name: sourceName
}, {})

